import { makeVar } from "@apollo/client";
import { DefaultWorklistASAMs } from "enums/Methods";
import {
  NucleofectionStep,
  SelectionProcess,
} from "features/WorklistTools/shared/interfaces";
import { WellSelection } from "../../shared/interfaces";
import { DestTransferStrategy } from "../NucleofectionInterfaces";

export interface INucleofectionInternalState {
  uploadedWorklist: boolean;
  uploadedNucleofectionPlate: boolean;
  destSelectionProcess: SelectionProcess;
  step: NucleofectionStep;
  selectedNucleofectionWells: WellSelection[];
  selectedIntermediateWells: WellSelection[];
  worklist: any[];
  worklistPreviewOpen: boolean;
  hoverWellId: string;
  isNucPlateAlreadyReserved: boolean;
  methodSettings: INucleofectionMethodSettings;
}

export interface INucleofectionMethodSettings {
  selectedSystem: number;
  arraySystemAutomationMethodId: number;
  destTransferStrategy: DestTransferStrategy;
  destSampleType: string;
}

export const NucleofectionInternalState = makeVar<INucleofectionInternalState>({
  uploadedWorklist: false,
  uploadedNucleofectionPlate: false,
  destSelectionProcess: SelectionProcess.Stamp,
  step: NucleofectionStep.SelectSourceAndCompound,
  selectedNucleofectionWells: [],
  selectedIntermediateWells: [],
  worklist: [],
  worklistPreviewOpen: false,
  hoverWellId: "",
  isNucPlateAlreadyReserved: false,
  methodSettings: {
    selectedSystem: 0,
    arraySystemAutomationMethodId: DefaultWorklistASAMs.Nucleofection,
    destTransferStrategy: DestTransferStrategy.NotSelected,
    destSampleType: "",
  },
});
